<template>
  <div class="label"><slot /></div>
</template>

<script>
/**
 * テキストラベル
 */
export default {
  name: 'TextLabel',
}
</script>

<style lang="postcss" scoped>
.label {
  align-items: center;
  background: var(--white);
  border: 1px solid var(--dark-gray-1);
  border-radius: 8px;
  box-sizing: border-box;
  color: var(--very-dark-gray-1);
  display: inline-flex;
  font-size: 13px;
  height: 16px;
  justify-content: center;
  line-height: 1;
  min-width: 32px;
  padding: 0 2px;
  width: fit-content;
}
</style>
